module.exports = __webpack_public_path__ + "img/call_missed.cbfaafa6.svg";